<div class="main_content px-3 position-relative">

    <div class="container-fluid py-3">
        <div class="title mb-4">
            <h3>My News</h3>
        </div>
        <div class="my-2">
            <button class="btn btn-success" (click)="openModal(AddNewsModal)">
                <i class="fa-solid fa-plus"></i> Add News
            </button>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 ">
                <div class="white_box shadow p-3">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Image</th>
                                <th scope="col">Title</th>
                                <th scope="col">Created At</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="news.length === 0">
                                <td colspan="5" class="text-center">No news available</td>
                            </tr>
                            <tr *ngFor="let item of news; let i = index;">
                                <th scope="row">{{i + 1}}</th>
                                <td>
                                    <img loading="lazy" [src]="imgUrl + item.image" alt="News Image" class="img-fluid"
                                        style="max-width: 100px; max-height: 100px;">
                                </td>
                                <td>{{item.title}}</td>
                                <td>{{convertDate(item.created)}}</td>
                                <td>
                                    <div class="btn-group" role="group" aria-label="Action buttons">
                                        <button type="button" class="btn btn-danger"
                                            (click)="handleDelete(item.user_details_new.id)">
                                            <i class="fa-solid fa-trash"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #AddNewsModal let-modal>
    <div class="modal-content">
        <div class="card">
            <div class="card-header text-dark d-flex justify-content-between align-items-center">
                <h5 class="modal-title mb-0">Add News</h5>
                <button type="button" class="btn-close btn-close-white" aria-label="Close"
                    (click)="modalService.dismissAll()"></button>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Image</th>
                                <th scope="col">Title</th>
                                <th scope="col">Created At</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let newsItem of relevantNews.data; let i = index;">
                                <th scope="row">{{i + 1}}</th>
                                <td>
                                    <img loading="lazy" [src]="imgUrl + newsItem.image" alt="News Image" class="img-fluid"
                                        style="max-width: 100px; max-height: 100px;">
                                </td>
                                <td>{{newsItem.title}}</td>
                                <td>{{convertDate(newsItem.created)}}</td>
                                <td>
                                    <div class="btn-group" role="group" aria-label="Action buttons">
                                        <button type="button" class="btn btn-danger"
                                            (click)="handleAddNews(newsItem.id)">
                                            <i class="fa-solid fa-plus"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <nav aria-label="Page navigation example">
                        <ul class="pagination">
                            <li class="page-item" [class.disabled]="news.currentPage === 1">
                                <a class="page-link" (click)="initNews(news.currentPage - 1)" aria-label="Previous">
                                    <span aria-hidden="true">&laquo;</span>
                                </a>
                            </li>
                            <li class="page-item" *ngFor="let page of [].constructor(news.lastPage); let i = index"
                                [class.active]="news.currentPage === i + 1">
                                <a class="page-link" (click)="initNews(i + 1)">{{ i + 1 }}</a>
                            </li>
                            <li class="page-item" [class.disabled]="news.currentPage === news.lastPage">
                                <a class="page-link" (click)="initNews(news.currentPage + 1)" aria-label="Next">
                                    <span aria-hidden="true">&raquo;</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
                <button type="button" class="btn btn-primary mr-2" (click)="handleUpload()" [disabled]="isUploading">
                    <i class="fas fa-save"></i> Save
                </button>
                <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()"
                    [disabled]="isUploading">
                    <i class="fas fa-times"></i> Cancel
                </button>
            </div>
        </div>
    </div>
</ng-template>